import React from "react";
import styled from "styled-components";
import ViewAppBar from "../views/ViewAppBar";
import ViewPosCadastroCotasEmpreendNaoChecados from "../views/ViewPosCadastroCotasEmpreendNaoChecados";
import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";

const ContainerComponente = styled.div`
  display: grid;
  grid-template: 100px 120vh 30vh / auto;
  @media (min-height: 1000px) {
    grid-template: 100px 90vh 50vh / auto;
  }
  @media (min-height: 1200px) {
    grid-template: 100px 80vh 60vh / auto;
  }
  @media (max-width: 300px) {
    grid-template: 100px 120vh 70vh / auto;
  }
  @media (min-width: 1000px) {
    grid-template: 100px 120vh 70vh / auto;
  }
`;

const PosCadastroCotasEmpreendNaoChecados: React.FC = () => (
  <>
    <ContatoZap />
    <ContainerComponente>
      <ViewAppBar />
      <ViewPosCadastroCotasEmpreendNaoChecados />
      <ViewFooter />
    </ContainerComponente>
  </>
);
export default PosCadastroCotasEmpreendNaoChecados;
